import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, of, Observable } from 'rxjs';

import { environment } from '@app/env-service';

import { BusinessType } from '../store/business-type.model';

@Injectable({
  providedIn: 'root',
})
export class BusinessTypeService {
  url :string = environment.url;

  _businessTypes = new BehaviorSubject<BusinessType[]>([]);
  public businessTypes$ = this._businessTypes.asObservable();

  gettingRecords :boolean;

  constructor(private http :HttpClient) {
    this.gettingRecords = true;
    this.http
      .get(`${this.url}/business_types`)
      .subscribe((data :BusinessType[]) => {
        this._businessTypes.next(<BusinessType[]>data);
        this.gettingRecords = false;
      });
  }

  getTypes() {
    return this._businessTypes.getValue();
  }

  getTypeFromId(id :number) {
    const businessTypes :any[] = this._businessTypes.getValue();

    return businessTypes.find((row) => row.id == id);
  }
}
